import { Box } from "@mui/material";
import { useContext } from "react";

import InvalidUser from "@/components/InvalidUser";
import TemplateContainer from "@/components/Templates/TemplateContainer.tsx";
import { DataContext } from "@/models/DataProvider.tsx";
export default function TemplateManagement({ newDesign }: { newDesign?: boolean }) {
  const { availableWorkspaceRoles } = useContext(DataContext);
  return (
    <>
      <InvalidUser
        validRoles={[availableWorkspaceRoles?.get("admin")?.role, availableWorkspaceRoles?.get("member")?.role]}
      />
      <Box
        sx={{
          maxWidth: newDesign ? "auto" : "1300px",
          mx: "auto",
          height: newDesign ? "100%" : "calc(100vh - 100px)",
          overflow: "hidden",
        }}
      >
        <TemplateContainer newDesign={newDesign} showRightPanel={false} header={true} />
      </Box>
    </>
  );
}
